function updateCfPdpSku(skuValue) {
  document.querySelectorAll('.cf-pdp__sku').forEach((el) => {
    const label = el.querySelector('.cf-pdp__sku-label');
    if (!label) {
      el.textContent = skuValue;
    } else {
      while (label.nextSibling) el.removeChild(label.nextSibling);
      el.appendChild(document.createTextNode(' ' + skuValue));
    }
    el.hidden = !skuValue;
  });
}

document.addEventListener('on:variant:change', (evt) => {
  const variant = evt.detail && evt.detail.variant;
  updateCfPdpSku(variant && variant.sku ? variant.sku : '');
});

document.addEventListener('change', (evt) => {
  const t = evt.target;
  if (!(t instanceof HTMLSelectElement) || t.id !== 'main_variant_select') return;
  const opt = t.options[t.selectedIndex];
  updateCfPdpSku(opt && opt.dataset.sku ? opt.dataset.sku : '');
});
